// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8f3ddf5e","isPdpNotListed":"_5d37a885","title":"_4c0065cd","artTitle":"_4a80dd6a"};